import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const Ingredient: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const { composition, headingColor, textColor, headingFontStyle, fontStyle } = context.product;

  return (
    <>
      {composition && (
        <div className="w-full max-w-2xl mx-auto px-4 py-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Ingredient
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {composition}
          </p>
        </div>
      )}
    </>
  );
};

export default Ingredient;
